import { createSlice } from "@reduxjs/toolkit";
import { CampaignPayments } from "types/campaign/payments";
import { fetchCampaignPayments } from "./thunk";

const initialState: CampaignPayments = {
    loading: false,
    error: null,
    campaigns: {}
}

const campaignPayments = createSlice({
    name: 'campaignPayments',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchCampaignPayments.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchCampaignPayments.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.error = null;

            const {campaignId, campaignPayment} = payload;

            state.campaigns[campaignId] = {
                ...campaignPayment,
                last_fetched_at: Date.now(),
                expired: false
            }

        })
        .addCase(fetchCampaignPayments.rejected, (state, {payload}) => {
            state.loading = false;
            state.error = payload ?? "Failed to fetch campaign payments!";
        })
    }


})

export default campaignPayments.reducer;